export enum SeturLoyaltyPointTransactionTypes {
  KREDI_KARTI_ILE_PUAN_CEVIR = 'KREDI_KARTI_ILE_PUAN_CEVIR',
  DIGER_MARKALARDAN_PUAN_CEVIR = 'DIGER_MARKALARDAN_PUAN_CEVIR',
  HARCAMA_ILE_PUAN_KAZAN = 'HARCAMA_ILE_PUAN_KAZAN',
  KREDI_KARTI_ILE_PUAN_SATIN_AL = 'KREDI_KARTI_ILE_PUAN_SATIN_AL',
  HEDIYE_KARTTAN_PUAN_KAZAN = 'HEDIYE_KARTTAN_PUAN_KAZAN',
  UYELIK_PUANI_KAZAN = 'UYELIK_PUANI_KAZAN',
  ADMIN_TARAFINDAN_PUAN_KAZAN = 'ADMIN_TARAFINDAN_PUAN_KAZAN',
  HARCANAN_PUANI_GERI_YUKLE = 'HARCANAN_PUANI_GERI_YUKLE',
  PUAN_HARCA = 'PUAN_HARCA',
  KAZANILAN_PUANI_IPTAL_ET_UYELIK_IPTALI = 'KAZANILAN_PUANI_IPTAL_ET_UYELIK_IPTALI',
  REFERANS_PUANI_KAZAN = 'REFERANS_PUANI_KAZAN',
  KAZANILAN_PUANI_IPTAL_ET_SEPET_IPTALI = 'KAZANILAN_PUANI_IPTAL_ET_SEPET_IPTALI',
  KAZANILAN_PUANI_IPTAL_ET_URUN_DEGISIKLIGI = 'KAZANILAN_PUANI_IPTAL_ET_URUN_DEGISIKLIGI',
  HARCANAN_PUANI_GERI_YUKLE_SEPET_DEGISIKLIGI = 'HARCANAN_PUANI_GERI_YUKLE_SEPET_DEGISIKLIGI',
  HARCANAN_PUANI_GERI_YUKLE_SEPET_IPTALI = 'HARCANAN_PUANI_GERI_YUKLE_SEPET_IPTALI',
}
